module.exports = __webpack_public_path__ + "img/top2.33d8cfea.png";